import createIcon from '../../createIcon';

/**
 * @component @name Portrait
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTIuMjVDMTMuMjQgMTIuMjUgMTQuMjUgMTEuMjQgMTQuMjUgMTBDMTQuMjUgOC43NiAxMy4yNCA3Ljc1IDEyIDcuNzVDMTAuNzYgNy43NSA5Ljc1IDguNzYgOS43NSAxMEM5Ljc1IDExLjI0IDEwLjc2IDEyLjI1IDEyIDEyLjI1Wk0xNi41IDE2LjI1QzE2LjUgMTQuNzUgMTMuNSAxNCAxMiAxNEMxMC41IDE0IDcuNSAxNC43NSA3LjUgMTYuMjVWMTdIMTYuNVYxNi4yNVpNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xOSAxOUg1VjVIMTlWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Portrait = createIcon('Portrait', [
  [
    'path',
    {
      d: 'M12 12.25C13.24 12.25 14.25 11.24 14.25 10C14.25 8.76 13.24 7.75 12 7.75C10.76 7.75 9.75 8.76 9.75 10C9.75 11.24 10.76 12.25 12 12.25ZM16.5 16.25C16.5 14.75 13.5 14 12 14C10.5 14 7.5 14.75 7.5 16.25V17H16.5V16.25ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z',
      key: 'i5x4w7',
    },
  ],
]);

export default Portrait;
